<div class="splitter">
    <div id="leftPane" class="pane" [style.width]="leftPaneWidth + 'px'">
      <ng-content select="[leftPanelContent]"></ng-content>
    </div>
    <div class="resizer" (mousedown)="startResizing($event)"></div>
    <div id="rightPane" class="pane">
      <ng-content select="[rightPanelContent]"></ng-content>
    </div>
  </div>
  